export default __webpack_public_path__ + "static/media/8N.0baad01e.jpg";